import { useState } from "react";
import { genreDefaultNote, genreList } from "@/mocks/anime";

export default function GenreSection() {
  const [activeId, setActiveId] = useState<string>("action");
  const active = genreList.find((item) => item.id === activeId);

  return (
    <section id="genres" className="w-full bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
            <i className="ri-price-tag-3-line" />
            题材分类导航
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            八种主要题材，帮你按口味找好看动漫
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            不知道自己想看什么？先按题材定位。点击下方任意分类，可以看到它的定位说明与代表作品。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {genreList.map((genre) => {
            const isActive = genre.id === activeId;
            return (
              <button
                key={genre.id}
                type="button"
                aria-pressed={isActive}
                onClick={() => setActiveId(genre.id)}
                className={`flex flex-col items-start gap-2 p-4 rounded-lg border text-left transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500 border-primary-500 text-background-50 dark:text-foreground-950"
                    : "bg-background-100 border-background-200 text-foreground-800 hover:border-primary-300"
                }`}
              >
                <span
                  className={`w-9 h-9 flex items-center justify-center rounded-md text-lg ${
                    isActive
                      ? "bg-background-50/20 text-background-50"
                      : "bg-background-50 text-primary-600"
                  }`}
                >
                  <i className={genre.icon} />
                </span>
                <span className="font-heading text-sm md:text-base font-semibold">
                  {genre.name}
                </span>
                <span className={`text-[11px] ${isActive ? "text-background-100/85" : "text-foreground-500"}`}>
                  {genre.count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-6 rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
          {active ? (
            <div className="flex flex-col lg:flex-row lg:items-start gap-5">
              <div className="lg:w-1/2">
                <div className="flex items-center gap-2">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-lg">
                    <i className={active.icon} />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">
                      {active.name}
                    </h3>
                    <p className="text-xs text-foreground-500">{active.count}</p>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{active.brief}</p>
              </div>
              <div className="lg:w-1/2 lg:border-l lg:border-background-200 lg:pl-6">
                <h4 className="text-xs font-medium text-foreground-500 mb-3">
                  <a href="#ranking" className="hover:text-primary-600 cursor-pointer">
                    代表作品
                  </a>
                </h4>
                <div className="flex flex-wrap gap-2">
                  {active.works.map((work) => (
                    <span
                      key={work}
                      className="px-3 py-1.5 rounded-md text-xs bg-background-50 text-foreground-700 border border-background-200"
                    >
                      {work}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <p className="text-sm text-foreground-500">{genreDefaultNote}</p>
          )}
        </div>
      </div>
    </section>
  );
}